module.exports = __webpack_public_path__ + "img/request-pin.8e8fdf86.svg";